import { TableFilterConfig, FilterFieldConfig } from 'hooks';
import { LOCAL_STORAGE_KEYS } from 'consts';

/**
 * Filter fields configuration for Documents Upload table (column filter ids align with MRT column ids / accessorKey).
 * apiKey maps to DocumentsQuery param names where they differ.
 */
export const DOCUMENT_UPLOAD_FILTER_FIELDS: FilterFieldConfig[] = [
  { id: 'fileName', type: 'text', label: 'File name' },
  { id: 'site', type: 'text', label: 'Site', apiKey: 'siteName' },
  { id: 'utilityType', type: 'text', label: 'Utility Type', apiKey: 'utilityName' },
  { id: 'uploader', type: 'text', label: 'Uploader' },
  { id: 'uploadDate', type: 'text', label: 'Uploaded at', apiKey: 'uploadedAt' },
  { id: 'pages', type: 'number', label: 'Pages' },
  { id: 'dataEntries', type: 'number', label: 'Data entries', apiKey: 'dataEntries' },
  { id: 'bills', type: 'text', label: 'Data entries status', apiKey: 'dataEntriesStatus' },
  { id: 'aiExtraction', type: 'text', label: 'AI Extraction' },
  { id: 'aiAlgorithm', type: 'text', label: 'AI Algorithm' },
];

export interface DocumentUploadFilters {
  fileName: string | null;
  site: string | null;
  utilityType: string | null;
  uploader: string | null;
  uploadDate: string | null;
  pages: number | null;
  dataEntries: number | null;
  bills: string | null;
  aiExtraction: string | null;
  aiAlgorithm: string | null;
}

export const createDocumentUploadFilterConfig = (): TableFilterConfig<DocumentUploadFilters> => ({
  localStorageKey: LOCAL_STORAGE_KEYS.DOCUMENT_UPLOAD_PAGE_COLUMN_FILTERS,
  filterMode: 'column',
  fields: DOCUMENT_UPLOAD_FILTER_FIELDS,
  displayNameMap: {
    fileName: 'File name',
    site: 'Site',
    utilityType: 'Utility Type',
    uploader: 'Uploader',
    uploadDate: 'Uploaded at',
    pages: 'Pages',
    dataEntries: 'Data entries',
    bills: 'Data entries status',
    aiExtraction: 'AI Extraction',
    aiAlgorithm: 'AI Algorithm',
  },
  columnIdMap: {
    fileName: 'fileName',
    site: 'site',
    utilityType: 'utilityType',
    uploader: 'uploader',
    uploadDate: 'uploadDate',
    pages: 'pages',
    dataEntries: 'dataEntries',
    bills: 'bills',
    aiExtraction: 'aiExtraction',
    aiAlgorithm: 'aiAlgorithm',
  },
});
